<template>
  <div @click="goToProjectDetails" class="project-name-table-cell" :class="{ viewable: canViewProjectDetails }">
    <div class="name">
      {{ item.asset }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { views } from '@/router/constants';
import { ACTIVE_TEST_CARD_TYPES, projectStatuses, testTypes } from '@/constants/projects';
import { userRoleGroups } from '@/constants/auth';

export default {
  name: 'ProjectNameTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['userRoleGroup']),
    activeTestCardTypes() {
      return Object.values(ACTIVE_TEST_CARD_TYPES);
    },
    isProjectAutomatic() {
      return this.item?.type === testTypes.AUTOMATIC;
    },
    isProjectActive() {
      return (this.isProjectAutomatic && this.activeTestCardTypes.includes(this.item.testCard?.type)) || false;
    },
    canViewProjectDetails() {
      return (
        this.userRoleGroup === userRoleGroups.CISO ||
        this.item.status === projectStatuses.FINISHED ||
        this.item.status === projectStatuses.IN_PROGRESS ||
        this.item.status === projectStatuses.IN_QUEUE
      );
    },
  },
  methods: {
    goToProjectDetails() {
      const to = 'projectDetails.tab.automatic.issues';
      if (this.canViewProjectDetails) {
        this.$router.push({ name: views.PROJECT_DETAILS, params: { id: this.item.id, to } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.project-name-table-cell {
  &:hover {
    &.viewable {
      cursor: pointer;

      .name {
        color: var(--brand-primary);
      }
    }
  }

  display: flex;
  flex-direction: column;
  justify-content: center;
}

.name {
  z-index: 4;
  color: var(--text-primary);
  display: flex;
  font-family: $font-family-bold;
  font-size: $font-size-base;
  font-weight: bold;
  letter-spacing: 0;
  line-height: rem(17);
}

.type {
  color: var(--text-primary);
  font-family: $font-family-regular;
  font-size: $font-size-sm;
  letter-spacing: 0;
  line-height: rem(15);
}
</style>
